function mockNativeApp() {
  try {
    if (typeof localStorage !== 'undefined') {
      return (
        localStorage
        && localStorage.getItem
        && localStorage.getItem('MOCK_NATIVE_APP')
      );
    }
    return false;
  } catch (err) {
    return false;
  }
}

export function isNativeApp() {
  const encodedNative = 'e1%3ds1';
  const cookie = document.cookie.toLowerCase();
  return (
    (cookie
      && cookie.indexOf('thd_online_channel') > -1
      && cookie.indexOf(encodedNative) > -1)
    || mockNativeApp()
  );
}

export const isLocalHost = () => {
  if (typeof window !== 'undefined') {
    const loc = window.location.hostname;
    const host = !!loc.match(/localhost/g);
    return host;
  }
  return false;
};

export const getTmxId = () => {
  if (typeof window === 'undefined') return null;
  const tmxID = window.top?.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId();
  return tmxID;
};

export const getJWT = () => {
  if (typeof window !== 'undefined') {
    return window?.THDCustomer?.default?.jwt;
  }
  return null;
};
